import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Row } from 'react-bootstrap';
import Card from '../Card/Card';

// Dynamically import images 1 through 30
const images = Array.from({ length: 30 }, (_, i) => 
  require(`../../assets/testTri/${i + 1}.png`)
);

const styles = {
  div1: { display: "flex", justifyContent: "center", alignItems: "center", height: "inherit", padding: "3px" },
  div2: { width: "80%", height: "80%", background: "#fff", boxShadow: "15px 15px 25px #ccc", borderRadius: "15px" },
  centerText: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  labelFont: { fontSize: '15px' },
  cell: { width: '115px', textAlign: 'center' }
};

const IntTestThree = () => {
  const history = useHistory();
  const auth = useSelector(state => state.auth);

  // Initial state for 30 questions
  const [answers, setAnswers] = useState(() =>
    Array.from({ length: 30 }, (_, i) => [`P${i + 1}`, '']).reduce(
      (acc, [key, val]) => ({ ...acc, [key]: val }), 
      {}
    )
  );

  // 8 minutes and 2 seconds = 482 seconds
  const [timeLeft, setTimeLeft] = useState(482);

  // Centralized submission logic
  const submitTest = useCallback(async (isAutoSubmit = false) => {
    try {
      const resp = await axios.post('/api/intApi/saveTestIIIResult', answers);
      await Swal.fire(
        isAutoSubmit ? 'Niste na vreme završili test, ali su rezultati poslati! ' : 'Poslato!',
        resp.data.message,
        resp.data.sign
      );
      history.push('/introIntTest');
    } catch (err) {
      console.error(err);
    }
  }, [answers, history]);

  // Radio button selection handler
  const onChange = (e) => {
    const { name, value } = e.target;
    setAnswers(prev => ({ ...prev, [name]: value }));
  };

  // Manual submission handler
  const onSubmit = (e) => {
    e.preventDefault();
    Swal.fire({
      title: 'Da li sigurno želiš da predaš test?',
      text: "Nećeš moći da ga radiš ponovo",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Ček da proverim',
      confirmButtonText: 'Predaj!'
    }).then((result) => {
      if (result.isConfirmed) {
        submitTest(false);
      }
    });
  };

  // Verify authorization on mount
  useEffect(() => {
    const checkAccess = async () => {
      try {
        const resp = await axios.post('/api/intApi/checkIfTestIsAccessed/', { whatTest: 'intIII' });
        if (resp.data.message === true) {
          await Swal.fire('Problem', 'Test je već rađen sa ovog naloga!', 'error');
          history.push('/introIntTest');
        }
      } catch (err) {
        console.error(err);
      }
    };
    checkAccess();
  }, [history]);

  // Countdown timer lifecycle
  useEffect(() => {
    if (timeLeft <= 0) {
      submitTest(true);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, submitTest]);

  // Convert total seconds to MM:SS format
  const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <div className="Content">
      <div style={{ position: 'fixed' }}>
        <Card content={<Row>Vreme: {formatTime(timeLeft)}</Row>} />
      </div>

      <div style={styles.div1}>
        <div style={styles.div2}>
          <div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
            <div style={{ padding: "16px 0", textAlign: "left" }}>
              <br /><br />
              <div style={styles.centerText}>
                Zdravo {auth?.user?.name}, pred tobom je treći deo testa sposobnosti, srećno!
              </div>
              <br /><br />

              {/* Loop to render questions 1 to 30 */}
              {images.map((imgSrc, index) => {
                const paramName = `P${index + 1}`;
                return (
                  <React.Fragment key={paramName}>
                    <div style={styles.centerText}>
                      <img style={{ width: '100%' }} alt={`imageExample${index + 1}`} src={imgSrc} />
                    </div>
                    <div style={styles.centerText}>
                      <table style={{ width: '642px' }}>
                        <tbody>
                          <tr>
                            <td style={{ width: '240px' }}></td>
                            {[1, 2, 3, 4].map(val => (
                              <td key={val} style={styles.cell}>
                                <div className="form-check">
                                  <label style={styles.labelFont}>
                                    <input
                                      onChange={onChange}
                                      type="radio"
                                      name={paramName}
                                      value={String(val)}
                                      checked={answers[paramName] === String(val)}
                                      className="form-check-input"
                                    /> {val}
                                  </label>
                                </div>
                              </td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br />
                  </React.Fragment>
                );
              })}

              <br />
              <div style={styles.centerText}>
                <input
                  type="submit"
                  value="Predaj test"
                  onClick={onSubmit}
                  className="btn-fill col-md-3 pull-center btn btn-info"
                  style={{ margin: '3px' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntTestThree;